// @flow
import React from 'react'
import I18n from 'i18n-react'
import Immutable from 'seamless-immutable'

import FieldForm from '../FieldForm'
import PatchSpecification from '../PatchSpecification'

// types
import type { FieldFormProps, FieldFormState } from '../FieldForm'
import type { ResourcesType } from '../../Types/Resources'
import type { FormValueType } from '../../Types/Values'

type StringEnumProps = FieldFormProps & {
  label?: string,
  resources: ResourcesType & {
    coverages: { [name: string]: any },
  },
}

type StringEnumState = FieldFormState & {}

export default class SupplementaryInsuranceForm extends React.Component<StringEnumProps, StringEnumState> {
  handleOnValueChange = (key: string, value: FormValueType, pathArray: Array<string>) => {
    const { specification, onChangeFormData, closeOnSelect } = this.props
    let { data, formData } = this.props
    const seats = specification.fields.filter((field) => field.name === 'seats')
    const carValue = specification.fields.filter((field) => field.name === 'carValue')
    data = Immutable(data || {})
    const variant = specification.fields.find((field) => field.name === 'variant')
    const numberOfDays = specification.fields.find((field) => field.name === 'numberOfDays')
    if (variant && !data.getIn(['variant'])) {
      this.props.onChangeValue('variant', variant.getIn(['domain', 'values', 0]), ['variant'])
      formData = Immutable(formData || {})
        .setIn([specification.name, 'variant'], variant.getIn(['domain', 'values', 0]))
        .setIn([specification.name, key], value)
      onChangeFormData(formData, ['limit', 'variant'], closeOnSelect)
    } else if (seats.length > 0) {
      formData = Immutable(formData || {})
        .merge(
          {
            [specification.name]: {
              seats: formData.seats,
            },
          },
          { deep: true },
        )
        .setIn([specification.name, key], value)
      onChangeFormData(formData, [key], true)
    } else if (carValue.length > 0) {
      formData = Immutable(formData || {})
        .merge(
          {
            [specification.name]: {
              carValue: formData.carValue,
            },
          },
          { deep: true },
        )
        .setIn([specification.name, key], value)
      onChangeFormData(formData, [key], true)
    } else
    if (numberOfDays && !data.getIn(['numberOfDays'])) {
      this.props.onChangeValue('numberOfDays', numberOfDays.getIn(['domain', 'values', 0]), ['numberOfDays'])
      formData = Immutable(formData || {})
        .setIn([specification.name, 'numberOfDays'], numberOfDays.getIn(['domain', 'values', 0]))
        .setIn([specification.name, key], value)
      onChangeFormData(formData, ['limit', 'numberOfDays'], closeOnSelect)
    } else {
      this.props.onChangeValue(key, value, pathArray)
    }
  }

  handleChangeSeatsFormData = (formData, path, value) => {
    const { onChangeFormData, specification } = this.props
    onChangeFormData(
      {
        ...formData,
        [specification.name]: {
          seats: formData.seats,
        },
      },
      [...path, specification.name],
      value,
    )
  }

  render() {
    const { specification, content } = this.props
    let { data, formData } = this.props
    const seats = specification.fields.filter((field) => field.name === 'seats')
    const carValue = specification.fields.filter((field) => field.name === 'carValue')
    const variant = specification.fields.find((field) => field.name === 'variant')
    const numberOfDays = specification.fields.find((field) => field.name === 'numberOfDays')
    const title = this.props.label || this.props.title

    if (!content || !content.fieldOrder) {
      return null
    }

    data = Immutable(data || {})
    if (variant && !data.getIn(['variant'])) {
      data = data.set('variant', variant.getIn(['domain', 'values', 0]))
    }
    formData = Immutable(formData || {})
    if (variant && !formData.getIn([specification.name, 'variant'])) {
      formData = formData.setIn([specification.name, 'variant'], variant.getIn(['domain', 'values', 0]))
    }

    if (numberOfDays && !data.getIn(['numberOfDays'])) {
      data = data.set('numberOfDays', numberOfDays.getIn(['domain', 'values', 0]))
    }
    if (numberOfDays && !formData.getIn([specification.name, 'numberOfDays'])) {
      formData = formData.setIn([specification.name, 'numberOfDays'], numberOfDays.getIn(['domain', 'values', 0]))
    }

    return (
      <div className="p-2 mw-100">
        {seats.length > 0 && (
          <PatchSpecification content={content} contentPatch={{ fieldOrder: ['seats'] }} specification={specification}>
            <FieldForm {...this.props} onChangeValue={() => {}} showBlockTitle={false} />
          </PatchSpecification>
        )}
        {carValue.length > 0 && (
          <PatchSpecification
            content={content}
            contentPatch={{ fieldOrder: ['carValue'] }}
            specification={specification}
          >
            <FieldForm {...this.props} onChangeValue={() => {}} showBlockTitle={false} />
          </PatchSpecification>
        )}
        <strong>{title}</strong>
        {variant && (
          <PatchSpecification
            content={content}
            contentPatch={{ fieldOrder: ['variant'] }}
            specification={specification}
          >
            <FieldForm {...this.props} data={data} formData={formData} labelClasses={[]} showBlockTitle={false} />
          </PatchSpecification>
        )}
        {numberOfDays && (
          <PatchSpecification
            content={content}
            contentPatch={{ fieldOrder: ['numberOfDays'] }}
            specification={specification}
          >
            <FieldForm {...this.props} data={data} formData={formData} labelClasses={[]} showBlockTitle={false} />
          </PatchSpecification>
        )}
        <div className="row my-2">
          <div className="col-4">
            <strong>{I18n.translate('components.supplementaryInsurance.limit')}</strong>
          </div>
          <div className="col-3">
            <strong>{I18n.translate('components.supplementaryInsurance.offer')}</strong>
          </div>
        </div>
        <hr className="border-0 border-sm-top" />
        <PatchSpecification
          content={content}
          contentPatch={{
            fieldOrder: content.fieldOrder.filter((field) => field !== 'seats' && field !== 'variant' && field !== 'numberOfDays')
          }}
          specification={specification}
        >
          <FieldForm
            {...this.props}
            data={data}
            formData={formData}
            onChangeValue={this.handleOnValueChange}
            showBlockTitle={false}
          />
        </PatchSpecification>
      </div>
    )
  }
}
